module.exports = __webpack_public_path__ + "img/stock3.3675134b.png";